import React from 'react';
import { useState } from 'react';
import { isMobile } from '../../helpers/helpers';



const VehicleTab = ({ activeTab, label, order, onClick }) => {
    const [showTab, setShowTab] = useState(true)
    const handlClick = () => {
        setShowTab(!showTab)
        onClick(order, showTab)

    }

    if (isMobile()) {
        var className = showTab ? ' tab-list-active' : '';
    } else if (activeTab === order) {
        var className = ' tab-list-active';
    }

    return (
        <li 
            tabIndex='0' 
            role="tab"
            className={`${className} tab-list-item`} 
            onClick={handlClick} 
            onKeyDown = {(e)=> e.key === 'Enter' && handlClick()}
            key={order}
        >
            <h3 tabIndex='0' className="tab-title" >{label}</h3>
        </li>
    );

}

export default VehicleTab;